import { cn } from '@/utils/cn';
import { formatMoney } from '@/utils/format';

export interface MoneyDisplayProps {
  amount: number;
  currency: string;
  colorBySign?: boolean;
  showSymbol?: boolean;
  parenthesiseNegative?: boolean;
  size?: 'sm' | 'md' | 'lg' | 'xl';
  className?: string;
}

const SIZES = {
  sm: 'text-body-sm',
  md: 'text-body',
  lg: 'text-section-title font-semibold',
  xl: 'text-display font-semibold',
} as const;

export const MoneyDisplay = ({
  amount,
  currency,
  colorBySign = false,
  showSymbol = true,
  parenthesiseNegative = true,
  size = 'md',
  className,
}: MoneyDisplayProps) => (
  <span
    className={cn(
      'font-numeric tabular-nums font-semibold whitespace-nowrap text-fg',
      SIZES[size],
      colorBySign && amount < 0 && 'text-danger-emphasis',
      colorBySign && amount > 0 && 'text-success-emphasis',
      className,
    )}
  >
    {formatMoney(amount, currency, { locale: 'en', showSymbol, parenthesiseNegative })}
  </span>
);
